import { FC } from "react";
import { useIntl } from "react-intl";

import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";

interface ImageLightboxProps {
  src: string;
  alt: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ImageLightbox: FC<ImageLightboxProps> = ({
  src,
  alt,
  open,
  onOpenChange,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-fit">
        <DialogHeader>
          <DialogTitle>{alt}</DialogTitle>
        </DialogHeader>
        <img
          src={src}
          alt={alt}
          className="max-h-[70vh] max-w-[85vw] rounded-md object-contain"
        />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">
              {formatMessage({ id: "common.close" })}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
